import AxiosHttpClient from "./axios-http-client";
import {
  BACKEND_BASE_URL,
  BACKEND_PASSWORD,
  BACKEND_USER,
} from "constants/default-values";

class ApiHttpClient extends AxiosHttpClient {
  constructor() {
    super({
      baseURL: BACKEND_BASE_URL,
      headers: { "Content-Type": "application/json" },
      auth: {
        username: BACKEND_USER,
        password: BACKEND_PASSWORD,
      },
    });
  }
}
export default new ApiHttpClient();
